import { render, staticRenderFns } from "./SeparationPersonName.vue?vue&type=template&id=fa3408f2"
import script from "./SeparationPersonName.vue?vue&type=script&lang=js"
export * from "./SeparationPersonName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports